import Vue from 'vue';
import VueRouter from 'vue-router';
import { MUTATION_NAME, ROUTES, EVENT_MESSAGES, UNSUPPORTED_BROWSERS } from '@/static/global-variables';
import restService from '@/services/restService';
import websocket from '@/services/websocket';
import utilities from '@/assets/scripts/utilities';
import store from '@/stores';
import routes from '@/router/routes';
import setData from '@/services/setData';
import formLogData from '@/services/formLogData';

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    }
});

router.beforeEach((to, from, next) => {
    let errorBody = null;
    let zoomMessage;
    let changed = false;
    if (from.name === ROUTES.EXPIRED) {
        return false
    }
    if (to.params.signinId) {
        changed = store.getters.signinId !== to.params.signinId;
        store.commit(MUTATION_NAME.SET_SIGNIN_ID, to.params.signinId);
        if(!store.getters.uuid) {
            store.commit(MUTATION_NAME.SET_UUID, to.params.uuid ? to.params.uuid : utilities.generateUuid())
        }
    }
    if(!store.getters.loaded) {
        restService.logEvent(formLogData.formSignatureLoad(store.getters.signinId))
    }
    if (UNSUPPORTED_BROWSERS.includes(utilities.getBrowserName()) && to.name !== ROUTES.UNSUPPORTED) {
        next({ name: ROUTES.UNSUPPORTED });
    } else if(to.name === ROUTES.SHARE_LINK) {
        if(!to.params.refreshed) {
            utilities.triggerRefresh(document.location.href);
        } else {
            store.commit(MUTATION_NAME.SET_CHANNEL_ID, to.params.channelId);
            websocket.generateClient(to.params.channelId, router);
            websocket.activate(router);
            next();
        }
    } else if (changed && (to.name === ROUTES.SIGNEE || to.name ===  ROUTES.SHARE_LINK_SIGNEE)) {
        restService.getSigninDetails(store.getters.signinId)
            .then(signatureResponse => {
                const data = JSON.parse(signatureResponse.data.data);
                zoomMessage = EVENT_MESSAGES.SAMPLE_REVIEW_GET_SUCCESS.replace('{0}', store.getters.signinId);
                restService.logEvent(formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, true, signatureResponse.status, zoomMessage));
                setData.setSamples(data, signatureResponse.headers);
                next();
            })
            .catch(error => {
                zoomMessage = EVENT_MESSAGES.SAMPLE_REVIEW_GET_FAIL.replace('{0}', store.getters.signinId).replace('{1}', error.response ? error.response.status : null).replace('{2}', error.message);
                if (error.response) {
                    errorBody = formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, true, error.response.status, zoomMessage);
                } else {
                    errorBody = formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, false, null, zoomMessage);
                }
                restService.logEvent(errorBody);
            });
    } else if (changed && (to.name === ROUTES.INQUIRIES || to.name ===  ROUTES.SHARE_LINK_INQUIRIES)) {
        restService.getSigninDetails(store.getters.signinId)
            .then(signatureResponse => {
                const data = JSON.parse(signatureResponse.data.data);
                zoomMessage = EVENT_MESSAGES.INQUIRY_REVIEW_GET_SUCCESS.replace('{0}', store.getters.signinId);
                restService.logEvent(formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, true, signatureResponse.status, zoomMessage));
                setData.setInquiries(data, signatureResponse.headers);
                next();
            })
            .catch(error => {
                zoomMessage = EVENT_MESSAGES.INQUIRY_REVIEW_GET_FAIL.replace('{0}', store.getters.signinId).replace('{1}', error.response ? error.response.status : null).replace('{2}', error.message);
                if (error.response) {
                    errorBody = formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, true, error.response.status, zoomMessage);
                } else {
                    errorBody = formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, false, null, zoomMessage)
                }
                restService.logEvent(errorBody);
            });
    } else if (changed && (to.name === ROUTES.SAMPLE_OPT_IN)) {
        restService.getSigninDetails(store.getters.signinId)
            .then(signatureResponse => {
                const data = JSON.parse(signatureResponse.data.data);
                zoomMessage = EVENT_MESSAGES.OPT_IN_GET_SUCCESS.replace('{0}', store.getters.signinId);
                restService.logEvent(formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, true, signatureResponse.status, zoomMessage));
                setData.setOptIn(data, signatureResponse.headers);
                next();
            })
            .catch(error => {
                zoomMessage = EVENT_MESSAGES.OPT_IN_GET_FAIL.replace('{0}', store.getters.signinId).replace('{1}', error.response ? error.response.status : null).replace('{2}', error.message);
                if (error.response) {
                    errorBody = formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, true, error.response.status, zoomMessage);
                } else {
                    errorBody = formLogData.formSignatureGet(store.getters.signinId, store.getters.preferredLanguage, false, null, zoomMessage);
                }
                restService.logEvent(errorBody);
            });
    } else if (changed && (to.name === ROUTES.AOC)) {
        restService.getSigninDetails(store.getters.signinId).then(aocResponse => {
            const data = JSON.parse(aocResponse.data.data);
            setData.setAoC(data, aocResponse.headers);
            next();
        }).catch(console.error);
    } else {
        next();
    }
});

export default router;
